module.exports = __webpack_public_path__ + "img/pv-07.456a9476.svg";